@let isLoading = loadingCases();
@let branch = selectedBranch();

<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'Grocery Case Portal'" data-testid="grocery-case-portal">
  <app-page-filters
    [allowBranchSelection]="true"
    branchSelectionLabel="Select Branch"
    [branchSelectionAutoSelectBranchIds]="defaultBranchIds()"
    [branchSelectionDisabled]="disableActions()"
    [branchRequestParams]="{ vertical: 'Grocery' }"
    [(selectedBranches)]="selectedBranch"
    (selectedBranchesChange)="onBranchSelection()"
  >
  </app-page-filters>

  @if (branch) {
    @let branchStat = branchStatistics();

    <hr class="my-2" />

    <div [attr.data-testid]="'branch-section-' + branchStat.branch_id">
      <app-branch-statistics
        [statistics]="branchStat"
        [(period)]="statsPeriod"
        (periodChange)="updatePeriod($event)"
      ></app-branch-statistics>

      <hr class="my-2" />

      <div class="flex mb-2" data-testid="branch-cases-filters">
        <div class="flex-1 flex gap-2">
          <app-pan-form-control>
            <app-pan-floating-label>Date From</app-pan-floating-label>
            <app-pan-datepicker
              [(date)]="pageIncidentDateFrom"
              [max]="pageIncidentDateTo()"
              [disabled]="disableActions()"
              (dateChange)="updatePeriodAndRefresh()"
              placeholder="Select start date"
              data-testid="branch-cases-date-from-filter"
            ></app-pan-datepicker>
          </app-pan-form-control>

          <app-pan-form-control>
            <app-pan-floating-label>Date To</app-pan-floating-label>
            <app-pan-datepicker
              [(date)]="pageIncidentDateTo"
              [min]="pageIncidentDateFrom()"
              [disabled]="disableActions()"
              (dateChange)="updatePeriodAndRefresh()"
              placeholder="Select end date"
              data-testid="branch-cases-date-to-filter"
            ></app-pan-datepicker>
          </app-pan-form-control>

          <app-pan-form-control>
            <app-pan-floating-label>Incident Type</app-pan-floating-label>
            <ng-select
              appendTo="body"
              placeholder="Select Incident Type"
              [items]="incidentTypeOptions()"
              [multiple]="true"
              [(ngModel)]="selectedIncidentTypes"
              (change)="refresh()"
              [disabled]="disableActions()"
              data-testid="branch-cases-incident-type-select"
            >
            </ng-select>
          </app-pan-form-control>

          <div class="flex items-end gap-1">
            @if (selectedCases().length > 0) {
              @if (activeTab() === "new") {
                <swal
                  #archiveSwal
                  title="Archive Cases?"
                  text="Are you sure you want to archive the {{ selectedCases().length }} selected case(s)?"
                  icon="question"
                  confirmButtonText="Yes, Archive"
                  [showCancelButton]="true"
                  [focusCancel]="true"
                  (confirm)="archiveSelectedCases()"
                >
                </swal>

                <app-pan-button color="warning" [swal]="archiveSwal" [disabled]="selectedCases().length === 0 || disableActions()">
                  Archive Cases
                </app-pan-button>
              }

              @if (activeTab() === "archived") {
                <swal
                  #restoreSwal
                  title="Restore Cases?"
                  text="Are you sure you want to restore the {{ selectedCases().length }} selected case(s)?"
                  icon="question"
                  confirmButtonText="Yes, Restore"
                  [showCancelButton]="true"
                  [focusCancel]="true"
                  (confirm)="restoreSelectedCases()"
                >
                </swal>

                <app-pan-button color="warning" [swal]="restoreSwal" [disabled]="selectedCases().length === 0 || disableActions()">
                  Restore Cases
                </app-pan-button>
              }
            }

            @if (selectedIncidents().length > 0) {
              @if (activeTab() === "new") {
                <swal
                  #archiveSwal
                  title="Archive Incidents?"
                  text="Are you sure you want to archive the {{ selectedIncidents().length }} selected incident(s)?"
                  icon="question"
                  confirmButtonText="Yes, Archive"
                  [showCancelButton]="true"
                  [focusCancel]="true"
                  (confirm)="archiveSelectedIncidents()"
                >
                </swal>

                <app-pan-button color="warning" [swal]="archiveSwal" [disabled]="selectedIncidents().length === 0 || disableActions()">
                  Archive Incidents
                </app-pan-button>
              }

              @if (activeTab() === "archived") {
                <swal
                  #restoreSwal
                  title="Restore Incidents?"
                  text="Are you sure you want to restore the {{ selectedIncidents().length }} selected incident(s)?"
                  icon="question"
                  confirmButtonText="Yes, Restore"
                  [showCancelButton]="true"
                  [focusCancel]="true"
                  (confirm)="restoreSelectedIncidents()"
                >
                </swal>

                <app-pan-button color="warning" [swal]="restoreSwal" [disabled]="selectedIncidents().length === 0 || disableActions()">
                  Restore Incidents
                </app-pan-button>
              }
            }
          </div>
        </div>

        <div class="flex items-end justify-end">
          <app-pan-button-group data-testid="branch-cases-tab-toggle">
            <app-pan-button
              color="info"
              [fill]="activeTab() === 'new' ? 'filled' : 'outline'"
              (click)="setActiveTab('new')"
              [disabled]="disableActions()"
              data-testid="branch-cases-tab-new"
            >
              New
            </app-pan-button>

            <app-pan-button
              color="info"
              [fill]="activeTab() === 'archived' ? 'filled' : 'outline'"
              (click)="setActiveTab('archived')"
              [disabled]="disableActions()"
              data-testid="branch-cases-tab-archived"
            >
              Archived
            </app-pan-button>
          </app-pan-button-group>
        </div>
      </div>

      @if (filteredTableEntries().length === 0) {
        <app-pan-inline-alert class="mb-2" type="info" data-testid="branch-cases-empty-state">
          No cases to review for the selected time period.
        </app-pan-inline-alert>
      }

      <ag-grid-angular
        [rowData]="filteredTableEntries()"
        [columnDefs]="columnDefs"
        [gridOptions]="tableDef"
        [getRowId]="getRowId"
        (gridReady)="onGridReady($event)"
        [loading]="isLoading"
        data-testid="branch-cases-grid"
      ></ag-grid-angular>
    </div>
  }

  @if (!branch && !isLoading) {
    <app-pan-blank-slate data-testid="no-branches-blank-slate">
      <span>Select a branch to view grocery cases</span>
    </app-pan-blank-slate>
  }

  @if (error(); as errorMessage) {
    <app-pan-inline-alert type="danger" class="mb-2" data-testid="error-alert">
      {{ errorMessage }}
    </app-pan-inline-alert>
  }
</app-pan-card>

<app-pan-modal size="xl" #detailModal [shouldBodyScroll]="true" (modalClose)="closeDetailModal()">
  <div header data-testid="detail-modal-header">
    {{ selectedIncidentCaseTitle() }}
  </div>

  <div body data-testid="investigation-detail">
    @if (isLoadingInvestigation()) {
      <div class="w-full flex justify-center py-12">
        <app-pan-spinner size="lg"></app-pan-spinner>
      </div>
    }

    @let investigation = selectedInvestigation();
    @if (investigation) {
      @let incidentRow = selectedIncidentRow();
      <div class="my-1 text-sm text-center italic">
        {{ investigation.date_of_instance | date: "medium" }}
      </div>

      <div class="flex flex-col gap-2">
        <div class="flex gap-2">
          <div class="flex-1 flex gap-2"><strong>Cashier:</strong> {{ incidentRow?.name || incidentRow?.cashier_id || "N/A" }}</div>

          <div class="flex-1 flex gap-2"><strong>Register:</strong> {{ incidentRow?.terminal_id ?? "N/A" }}</div>

          <div class="flex-1"></div>
          <div class="flex-1"></div>
        </div>

        <div class="flex gap-2">
          <div class="flex-1 flex gap-2"><strong>Item Count:</strong> {{ totalItemCount() }}</div>

          <div class="flex-1 flex gap-2"><strong>Loss Detected:</strong> {{ selectedIncidentRow()?.loss_amount | currency }}</div>

          <div class="flex-1 flex gap-2"><strong>Loss Represented:</strong> {{ selectedIncidentRow()?.loss_represented | currency }}</div>

          <div class="flex-1"></div>
        </div>

        <div class="my-2">
          <app-pan-section-header [title]="'Incident Summary'"></app-pan-section-header>

          <div class="mt-2 whitespace-pre-line">
            @if (selectedIncidentRow()?.review_summary; as summary) {
              {{ summary }}
            } @else {
              <div class="text-muted">No summary available</div>
            }
          </div>
        </div>

        <div class="flex gap-4 flex-row" data-testid="detail-body">
          <div class="flex-[3] min-w-0">
            <app-pan-section-header [title]="'Video(s)'"></app-pan-section-header>
            <div class="border rounded-b p-4" data-testid="detail-evidence">
              @for (item of evidenceItems(); track $index) {
                @if ($index === currentEvidenceIndex()) {
                  <div class="flex flex-col items-center gap-4">
                    @if (item.type === "video") {
                      <div class="w-full">
                        <app-pan-video [src]="item.url" [showControls]="true" data-testid="evidence-video"></app-pan-video>
                      </div>
                    } @else if (item.type === "video-link") {
                      <div class="flex flex-col items-center gap-2 py-4">
                        <a panButton icon="open_in_new" size="sm" [href]="item.url" target="_blank" rel="noopener noreferrer"> Open {{ item.label }} </a>
                        @if (item.password) {
                          <span class="text-xs text-muted">Password: {{ item.password }}</span>
                        }
                      </div>
                    }
                  </div>
                }
              } @empty {
                <div class="text-center text-muted py-4">No videos available</div>
              }
            </div>
          </div>
        </div>

        <div class="flex justify-center my-4" panRole [roles]="['admin', 'branch-owner', 'branch-manager', 'market-manager']">
          <app-discussion-thread type="investigation-report" [id]="investigation.review_id"></app-discussion-thread>
        </div>
      </div>
    }

    @if (!isLoadingInvestigation() && !investigation) {
      <div class="w-full flex justify-center py-12 text-muted">Failed to load investigation details.</div>
    }
  </div>

  <div footer class="flex w-full min-w-0 flex-wrap items-center justify-end gap-3">
    @if (selectedInvestigation() && evidenceItems().length > 1 && currentEvidenceItem()) {
      <div class="mr-auto flex items-center gap-3">
        <app-pan-button
          color="info"
          fill="outline"
          [disabled]="currentEvidenceIndex() === 0"
          (click)="previousEvidence()"
          data-testid="evidence-prev"
        >
          Previous
        </app-pan-button>

        <span class="text-sm text-muted"> {{ currentEvidenceIndex() + 1 }} / {{ evidenceItems().length }} </span>

        <app-pan-button
          color="info"
          fill="outline"
          [disabled]="currentEvidenceIndex() === evidenceItems().length - 1"
          (click)="nextEvidence()"
          data-testid="evidence-next"
        >
          Next
        </app-pan-button>
      </div>
    }

    <app-pan-button icon="share" color="info" [panCopyText]="currentPageURL()">Copy Link</app-pan-button>

    <app-pan-button panModalClose data-testid="detail-modal-close">Close</app-pan-button>
  </div>
</app-pan-modal>
